<template>
  <div class="product-trust-highlight">
    <div class="product-trust-highlight__image-container">
      <img
        :alt="imageAlt"
        class="product-trust-highlight__image"
        :src="imageSrc"
      />
    </div>

    <div ref="statsCardRef" class="product-trust-highlight__stats-card">
      <STooltipInfo
        class="product-trust-highlight__info-tooltip"
        :tooltip="
          tr('main_site.company_wall.municipality.hero.stats.info_tooltip', {
            customer_pl: customerPlural ?? '',
          })
        "
        :trigger-el="statsCardRef ?? undefined"
      />

      <div class="product-trust-highlight__stat">
        <span class="product-trust-highlight__stat-value">
          <RoundedSpecialistCount :count="specialistsCount" />
        </span>
        <span class="product-trust-highlight__stat-label">
          {{
            tr(
              "main_site.company_wall.municipality.hero.stats.total_specialists",
            )
          }}
        </span>
      </div>

      <div class="product-trust-highlight__stat">
        <div class="product-trust-highlight__stat-value-with-icon">
          <i class="fas fa-star product-trust-highlight__star-icon" />
          <span class="product-trust-highlight__stat-value">
            {{ averageScore }}
          </span>
        </div>
        <span class="product-trust-highlight__stat-label">
          {{
            tr("main_site.company_wall.municipality.hero.stats.average_score")
          }}
        </span>
      </div>

      <div class="product-trust-highlight__stat">
        <span class="product-trust-highlight__stat-value">
          {{ reviewsCount }}
        </span>
        <span class="product-trust-highlight__stat-label">
          {{
            tr("main_site.company_wall.municipality.hero.stats.total_reviews")
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from "vue";

import { STooltipInfo } from "@solvari/common-fe";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

import RoundedSpecialistCount from "~/features/company-wall/components/company-wall-hero/RoundedSpecialistCount.vue";

const { tr } = useI18nMainSiteCompanyWall();

defineProps<{
  averageScore: number;
  customerPlural: string | null;
  imageAlt: string;
  imageSrc: string;
  reviewsCount: number;
  specialistsCount: number;
}>();

const statsCardRef = useTemplateRef<HTMLElement>("statsCardRef");
</script>

<style lang="postcss">
.product-trust-highlight {
  @apply relative flex w-104 flex-col items-center justify-end;

  &__image-container {
    @apply absolute bottom-6 flex w-full justify-center;
  }

  &__image {
    @apply h-full w-88 object-contain object-bottom;
  }

  &__stats-card {
    @apply absolute -bottom-10 z-10 flex w-full items-center justify-center rounded-md border border-primary-100 bg-white p-3 shadow-md gap-1;
  }

  &__info-tooltip {
    @apply absolute right-2 top-1;
  }

  &__stat {
    @apply flex flex-1 flex-col items-center justify-center text-center;
  }

  &__stat-value-with-icon {
    @apply flex items-center justify-center gap-1;
  }

  &__star-icon {
    @apply mb-1 text-lg text-primary-700;
  }

  &__stat-value {
    @apply text-xl font-medium leading-7 text-primary-700;
  }

  &__stat-label {
    @apply text-sm font-medium leading-5 text-slate-500;
  }
}
</style>
